import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitTo'
})
export class LimitToPipe implements PipeTransform {

  transform(lista: Array<any>, tamanho: any): any {
    const novaLista: Array<any> = [];
    for (let i = 0; i < tamanho; i++) {
      if (lista[i] !== undefined && lista[i] !== '') {
        novaLista[i] = lista[i];
      }
    }

    return novaLista;
  }


}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/limit-to.pipe.ts